export default "__VITE_ASSET__BaF64dgs__"